import { IQuoteDetail } from "models/QuoteDetail";

export interface IHistoryBudgetSale {
  supplierProductDescription: string,
  supplierProductCode: string,
  distributionCenter: string,
  description: string,
  rentability: number,
  price: number,
  date: string,
}

export interface IGroupPriceHistory {
  historyBudget: Array<IHistoryBudgetSale>,
  historySale: Array<IHistoryBudgetSale>,
  lastBudget: IHistoryBudgetSale,
  lastSale: IHistoryBudgetSale,
  factoryPrice: number,
}

export interface PriceHistoryModalProps {
  item: any;
  onCloseAction: Function;
  ableNegotiacionBtn?: boolean;
  quoteDetail: IQuoteDetail | undefined;
}

export const settings = {
  dots: false,
  arrows: false,
  infinite: false,
  speed: 100,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 6
      }
    },
    {
      breakpoint: 1055,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 885,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 745,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 545,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 445,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 365,
      settings: {
        slidesToShow: 1
      }
    }
  ]
};